import React from 'react';
import { Check } from 'lucide-react';

const publicPath = (p) => (process.env.PUBLIC_URL || '') + p;
const aboutImage = publicPath('/assets/students/student11.jpeg');

const points = [
  'Handpicked tutors from top universities and schools',
  'Regular parent-teacher progress reports',
  'Doubt-solving anytime via WhatsApp with your tutor',
  'Free demo class before you commit',
  'Flexible re-scheduling and tutor replacement'
];

export default function About() {
  return (
    <section id="about" className="bg-[#FFF8EC] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative order-2 lg:order-1">
          <div className="absolute -top-4 -left-4 w-20 h-20 rounded-2xl bg-[#F4B93E] rotate-12" />
          <div className="relative rounded-3xl overflow-hidden border-2 border-[#2C3E50] paper-shadow-teal">
            <img src={aboutImage} alt="Students learning at home" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-white border-2 border-[#2C3E50] rounded-2xl p-4 paper-shadow-sm hidden sm:block">
            <div className="text-2xl font-black text-[#E64B2B]" style={{ fontFamily: 'Fraunces, serif' }}>10+ yrs</div>
            <div className="text-xs font-bold text-[#2C3E50]/70 uppercase tracking-wider">of teaching</div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="text-[#E64B2B] uppercase tracking-[0.25em] font-black text-xs">About Pikachu Classes</span>
          <h2 className="mt-3 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            Learning that fits your child, <span className="text-[#4FB3B8]">not the other way around.</span>
          </h2>
          <p className="mt-5 text-[#2C3E50]/80 text-lg leading-relaxed">
            Pikachu Classes was born out of a simple belief — every child learns differently and deserves a mentor who truly listens. Starting from Noida and now serving families across India, our tutors bring warmth, structure and results to your living room (or laptop).
          </p>
          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {points.map((p) => (
              <li key={p} className="flex gap-3 items-start">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-[#4FB3B8] text-white flex items-center justify-center shrink-0">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="font-semibold text-[#2C3E50]">{p}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#subjects" className="px-5 py-3 rounded-md bg-[#E64B2B] text-white font-black border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5">Explore Subjects</a>
            <a href="#reviews" className="px-5 py-3 rounded-md bg-transparent text-[#2C3E50] font-bold border-2 border-[#2C3E50] hover:bg-[#2C3E50] hover:text-[#FFF8EC]">Read Parent Reviews</a>
          </div>
        </div>
      </div>
    </section>
  );
}
